import { DatePickerMode } from "./DatePicker.types";
import { PickerStrategy } from "./DatePickerStrategy";
import { useRangeDatePicker, UseRangeDatePickerParams } from "./useRangeDatePicker.hook";
import { useSingleDatePicker, UseSingleDatePickerParams } from "./useSingleDatePicker.hook";

type UseDatePickerStrategyParams = UseRangeDatePickerParams &
  UseSingleDatePickerParams & { mode: DatePickerMode; displayInUTC?: boolean };

export const useDatePickerStrategy = ({
  mode,
  displayInUTC,
  ...params
}: UseDatePickerStrategyParams): PickerStrategy => {
  const single = useSingleDatePicker({ ...params, displayInUTC });
  const range = useRangeDatePicker(params);

  return mode === DatePickerMode.SINGLE ? single : range;
};